import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      "Contains GL IDC Group: Used to group GL expenses for an IDC base review. Generally corresponds to one or more segments of the institution's GL chartstring, such as fund/purpose and project/activity, that are relevant when functionalizing expenses for an IDC base review",
    name: 'General Ledger IDC Groups',
    partialId: PartialId.Standard.create('gl_idc_groups'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
